import React from "react"
import propTypes from "prop-types"
import { connect } from "react-redux"
import { CSSTransition, TransitionGroup } from "react-transition-group"
import Loader from "react-loader-spinner"
import iconFile from "./images/icon-file.svg"
import { filesUpload } from "../../../../services/plans"

import ErrorMessage from "../ErrorMessage"

const File = ({ field, onChange, isSubmitted, store, onFileUpload }) => {
  const handleFileDelete = (e, index) => {
    e.preventDefault()

    const newValue = field.value
    newValue.splice(index, 1)

    onChange(field.name, "value", newValue)
  }

  const handleFileChosen = (files, target) => {
    const t = target
    const fileList = new FormData()

    for (let i = 0; i < files.length; i += 1) {
      fileList.append("files", files[i])
    }

    onFileUpload(store.user.token, fileList).then(data => {
      const newData = field.value.concat(data)
      onChange(field.name, "value", newData)
      t.value = null
    })
  }

  return (
    <div
      className={[
        "form_file",
        field.class,
        isSubmitted && !!field.message && field.required ? " is-invalid" : ""
      ].join(" ")}
    >
      {field.description && (
        <div className="form_file_description">{field.description}</div>
      )}

      <ul className="form_file_list">
        <TransitionGroup component={null}>
          {field.value.map((file, index) => {
            const key = `file_${index}`

            return (
              <CSSTransition
                key={key}
                timeout={300}
                classNames="form_file_item"
              >
                <li className="form_file_item">
                  <a
                    className="form_file_item_delete"
                    href="/#"
                    onClick={e => {
                      handleFileDelete(e, index)
                    }}
                  >
                    delete
                  </a>
                  <img
                    src={iconFile}
                    alt={file.name_file}
                    title={file.name_file}
                  />
                </li>
              </CSSTransition>
            )
          })}
        </TransitionGroup>
      </ul>

      <label
        htmlFor={field.name}
        className={`form_file_btn ${
          store.fileUploading ? "form_file_btn--disabled" : ""
        }`}
      >
        {field.label}
        <input
          id={field.name}
          type={field.type}
          disabled={store.fileUploading}
          multiple
          name={field.name}
          accept={field.accept}
          onChange={e => handleFileChosen(e.target.files, e.target)}
          className="form_element"
        />
      </label>

      {store.fileUploading && (
        <Loader
          type="TailSpin"
          color="#0c4632"
          height={40}
          width={40}
          className="form_file_loading"
        />
      )}

      <ErrorMessage message={field.message} />
    </div>
  )
}

File.propTypes = {
  onFileUpload: propTypes.func.isRequired,
  field: propTypes.shape({
    label: propTypes.string,
    description: propTypes.string,
    name: propTypes.string.isRequired,
    type: propTypes.string.isRequired,
    accept: propTypes.string,
    value: propTypes.arrayOf(
      propTypes.shape({
        name: propTypes.string,
        content: propTypes.string
      })
    ).isRequired,
    message: propTypes.string,
    icon: propTypes.string,
    required: propTypes.bool.isRequired,
    class: propTypes.string
  }).isRequired,
  onChange: propTypes.func.isRequired,
  isSubmitted: propTypes.bool.isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      token: propTypes.string
    }),
    fileUploading: propTypes.bool
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer, PlansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    fileUploading: PlansReducer.fileUploading
  }
})

const mapDispatchToProps = dispatch => ({
  onFileUpload: (token, fileList) => dispatch(filesUpload(token, fileList))
})

export default connect(mapStateToProps, mapDispatchToProps)(File)
